@file:OptIn(InternalResourceApi::class)

package tedd_app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/tedd_app.shared.generated.resources/"

@delegate:ResourceContentHash(-314_788_611)
internal val Res.font.OFL_bricolagegrotesque: FontResource by lazy {
      FontResource("font:OFL_bricolagegrotesque", setOf(
        ResourceItem(setOf(), "${MD}font/OFL-bricolagegrotesque.txt", -1, -1),
      ))
    }

@delegate:ResourceContentHash(922_825_526)
internal val Res.font.OFL_geist: FontResource by lazy {
      FontResource("font:OFL_geist", setOf(
        ResourceItem(setOf(), "${MD}font/OFL-geist.txt", -1, -1),
      ))
    }

@delegate:ResourceContentHash(922_825_526)
internal val Res.font.OFL_geistmono: FontResource by lazy {
      FontResource("font:OFL_geistmono", setOf(
        ResourceItem(setOf(), "${MD}font/OFL-geistmono.txt", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_961_544_276)
internal val Res.font.bricolage_grotesque: FontResource by lazy {
      FontResource("font:bricolage_grotesque", setOf(
        ResourceItem(setOf(), "${MD}font/bricolage_grotesque.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_371_614_965)
internal val Res.font.geist: FontResource by lazy {
      FontResource("font:geist", setOf(
        ResourceItem(setOf(), "${MD}font/geist.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-296_278_194)
internal val Res.font.geist_mono: FontResource by lazy {
      FontResource("font:geist_mono", setOf(
        ResourceItem(setOf(), "${MD}font/geist_mono.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("OFL_bricolagegrotesque", Res.font.OFL_bricolagegrotesque)
  map.put("OFL_geist", Res.font.OFL_geist)
  map.put("OFL_geistmono", Res.font.OFL_geistmono)
  map.put("bricolage_grotesque", Res.font.bricolage_grotesque)
  map.put("geist", Res.font.geist)
  map.put("geist_mono", Res.font.geist_mono)
}
